import React from 'react';

import { TextField } from '@johnlewispartnership/wtr-ingredients/ingredients/Forms';

import styles from './SearchInput.scss';

interface SearchInputProps {
  dataTag: string;
  errorText?: string;
  id: string;
  ariaDescribedBy?: string;
  onBlur: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  required?: boolean;
  value: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  dataTag,
  errorText = '',
  id,
  ariaDescribedBy = '',
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  required,
  value,
}) => (
  <div className={styles.searchInput}>
    <TextField
      ariaDescribedBy={ariaDescribedBy}
      autoComplete="off"
      data-test={dataTag}
      errorText={errorText}
      helpText="Start typing an address or postcode"
      id={id}
      label="Address finder"
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      required={required}
      type="text"
      value={value}
    />
  </div>
);

export default SearchInput;
